import React from 'react';
import SkeletonLoader from 'tiny-skeleton-loader-react';

const Row = ({ columnsCount = 4 }) => {
  // Créer le template de grille avec la première colonne double largeur et les 2 dernières en 0.5fr
  let gridTemplate = '2fr'; // Première colonne (titre/icône)
  const remainingColumns = columnsCount - 1;

  if (remainingColumns >= 2) {
    // S'il y a au moins 2 colonnes après la première
    if (remainingColumns > 2) {
      // Colonnes du milieu en 1fr
      gridTemplate += ` repeat(${remainingColumns - 2}, minmax(120px, 1fr))`;
    }
    // Deux dernières colonnes en 0.5fr
    gridTemplate += ' 0.5fr 0.5fr';
  } else if (remainingColumns === 1) {
    // Une seule colonne après la première, elle fait 0.5fr
    gridTemplate += ' 0.5fr';
  }

  return (
    <div
      className="tw-p-3"
      style={{
        display: 'grid',
        gridTemplateColumns: gridTemplate,
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      {/* Première colonne : Icône et titre */}
      <div className="tw-flex tw-items-center tw-min-w-0">
        <SkeletonLoader width={20} height={20} />
        <div className="tw-ml-2 tw-min-w-0 tw-flex-1">
          <SkeletonLoader width={150} height={20} />
          <SkeletonLoader style={{ marginTop: 2 }} width={200} height={16} />
        </div>
      </div>

      {/* Colonnes pour les champs (nombre variable selon columnsCount) */}
      {Array.from({ length: columnsCount - 1 }).map((_, index) => {
        const isLastTwoColumns =
          remainingColumns >= 2 && index >= remainingColumns - 2;
        const skeletonWidth = isLastTwoColumns ? 60 : 80; // Plus petites pour les 2 dernières colonnes
        const skeletonValueWidth = isLastTwoColumns ? 45 : 60;

        return (
          <div
            key={index}
            className="tw-flex tw-flex-col tw-items-center tw-min-w-0"
          >
            <SkeletonLoader
              width={skeletonWidth}
              height={16}
              style={{ marginBottom: 4 }}
            />
            <SkeletonLoader width={skeletonValueWidth} height={16} />
          </div>
        );
      })}
    </div>
  );
};

export default function GenericTableSkeleton({
  numberOfRows = 4,
  hasTitle,
  columnsCount = 4,
}) {
  return (
    <div className="tw-mt-4">
      {hasTitle && (
        <div className="tw-mb-4">
          <SkeletonLoader height={24} width={150} />
        </div>
      )}
      <div className="tw-rounded-md tw-bg-white tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background tw-overflow-x-auto">
        <div className="tw-w-full tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-background">
          {[...Array(numberOfRows).keys()].map((_, index) => (
            <Row key={index} columnsCount={columnsCount} />
          ))}
        </div>
      </div>
    </div>
  );
}
